module.exports = __webpack_public_path__ + "img/dive_logo.42597692.png";